import { render, staticRenderFns } from "./SkinView.vue?vue&type=template&id=025819b0&scoped=true"
import script from "./SkinView.vue?vue&type=script&lang=js"
export * from "./SkinView.vue?vue&type=script&lang=js"
import style0 from "./SkinView.vue?vue&type=style&index=0&id=025819b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025819b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025819b0')) {
      api.createRecord('025819b0', component.options)
    } else {
      api.reload('025819b0', component.options)
    }
    module.hot.accept("./SkinView.vue?vue&type=template&id=025819b0&scoped=true", function () {
      api.rerender('025819b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/SkinView.vue"
export default component.exports